import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";
import {
    Tooltip,
    TooltipGlobalStyle,
    WorthyThemeProvider,
} from "@worthy-npm/worthy-ui-components";
import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";
import { imageUrl } from "../../helpers/ApplicationHelper";

const InputContainer = styled.div`
    display: flex;
    justify-content: center;

    & > div {
        max-width: 360px;
    }

    &&& {
        * {
            line-height: 1;
        }
    }
`;

const CertificateTooltip = (props) => {
    const isMobile = window.innerWidth < 568;
    return (
        <InputAdornment {...props} style={{marginRight: '10px'}}>
            <WorthyThemeProvider>
                <TooltipGlobalStyle />
                <Tooltip
                    placement={isMobile ? "topRight" : "top"}
                    trigger={isMobile ? "click" : "hover"}
                    align={{ offset: isMobile ? [30, 0] : [0, 0] }}
                    zIndex={10001}
                    content={
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                maxWidth: 200,
                            }}
                        >
                            <span style={{ marginBottom: 10 }}>
                                6 -10 digit number at the top of your GIA report
                            </span>
                            <img
                                style={{ width: 196, height: 72 }}
                                src={imageUrl("common/gia-sample.png")}
                            />
                        </div>
                    }
                >
                    <img
                        src={imageUrl("common/question.svg")}
                        alt="Certificate details"
                    />
                </Tooltip>
            </WorthyThemeProvider>
        </InputAdornment>
    );
};

const Text = (props) => {
    const {
        question,
        containerClassName = "free-text-container",
        value = "",
        placeholder = "Report number",
        type,
        inputmode,
        min,
        max,
    } = props;

    const isGIACertificate = [
        "gia_cert_number_standalone",
        "gia_cert_number",
    ].includes(question.key);

    const isNumericInput = type === "number" || inputmode === "numeric";
    const onChange = (e) => {
        if (isNumericInput) {
            const hasInvalidCharacters = /[^\d]/.test(e.target.value);
            const isBelowMin =
                typeof min === "number" ? Number(e.target.value) < min : false;
            const isAboveMax =
                typeof max === "number" ? Number(e.target.value) > max : false;

            if (hasInvalidCharacters || isBelowMin || isAboveMax) return;
        }
        props.onChange(e);
    };

    return (
        <div className={containerClassName}>
            <span className={"question"}>{question.q}</span>
            <InputContainer className="deterministic-outlined-input">
                <TextField
                    label=""
                    variant="outlined"
                    id="deterministic-outlined-input"
                    placeholder={placeholder}
                    fullWidth
                    autoFocus
                    onChange={onChange}
                    value={value}
                    InputProps={{
                        type,
                        inputMode: inputmode,
                        endAdornment: isGIACertificate ? (
                            <CertificateTooltip/>
                        ) : undefined,
                        classes: {
                            adornedEnd: 'end-adornment-container'
                        }
                    }}
                />
            </InputContainer>
        </div>
    );
};

Text.propTypes = {
    question: PropTypes.shape({
        answers: PropTypes.arrayOf(PropTypes.string),
        other: PropTypes.bool,
        q: PropTypes.string,
        key: PropTypes.string,
    }),
    onChange: PropTypes.func,
    value: PropTypes.string,
    containerClassName: PropTypes.string,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    inputmode: PropTypes.string,
    min: PropTypes.number,
    max: PropTypes.number,
};

export default Text;
